<script>
export default {
  name: "InputCount",
  props: {
    modelValue: Number,
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    required: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    increment() {
      if (this.disabled) return;

      let value = this.modelValue;
      if (value < this.max) value += 1;
      if (value < this.min) value = this.min;

      this.$emit('update:modelValue', value);
    },
    decrement() {
      if (this.disabled) return;

      let value = this.modelValue;
      if (this.modelValue > this.min) value -= 1;
      else if(this.required) value = this.min;
      else value = 0;
      this.$emit('update:modelValue', value);
    },
  }
}
</script>

<template>
  <div class="tw-flex">
    <div class="tw-flex tw-w-auto tw-items-center tw-rounded-2xl tw-bg-[#f5efe5] tw-px-3 tw-py-2 tw-text-[#2d2924]" :class="{'tw-opacity-60': disabled}">
      <div @click="decrement()" class="tw-select-none" :class="disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'">
        <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 20 20">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7 11.7v-1.4H4.3v1.4h11.4Z"
                fill="currentColor"></path>
        </svg>
      </div>
      <div class="tw-w-[20px] tw-text-center tw-font-medium tw-text-lg tw-select-none">
        {{modelValue}}
      </div>
      <div @click="increment()" class="tw-select-none" :class="disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'">
        <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 20 20">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.3 11.7v5h1.4v-5h5v-1.4h-5v-5H9.3v5h-5v1.4h5Z"
                fill="currentColor"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
